import { $apiV5 } from "@plugins/axios";

const API = {
  products: "/iap/stripe/products",
  checkout: "/iap/stripe/checkout",
};

const unwrapResponse = (data) => data?.data || data;

export const fetchStripeProducts = async (params = {}) => {
  try {
    const { data } = await $apiV5.get(API.products, { params });
    const result = unwrapResponse(data);
    return result?.products || [];
  } catch (error) {
    console.error("fetchStripeProducts error", error);
    throw error?.response?.data || error;
  }
};

export const createStripeCheckout = async (payload = {}) => {
  try {
    const { data } = await $apiV5.post(API.checkout, payload);
    return unwrapResponse(data);
  } catch (error) {
    console.error("createStripeCheckout error", error);
    throw error?.response?.data || error;
  }
};
